<template>
  <div class="detalle-producto">
    <div class="form-group">
      <div class="input-group">
        <MarcaProducto />
      </div>
      <div class="input-group">
       <Medida />
      </div>
      <div class="input-group">
        <Paises />
      </div>
    </div>
    <div class="form-group">
      <div class="input-group">
        <Observacion />
      </div>
    </div>
    <div class="form-group">
      <div class="input-group">
        <label for="flag">Venta caja</label>
        <input id="flag" style="width: 30px;" type="checkbox" class="pointer" v-model="flagVentaCaja">
      </div>
    </div>
  </div>
</template>

<script>
  import MarcaProducto from "./MarcaProducto";
  import Medida from "./Medida";
  import Paises from "./Paises";
  import Observacion from "./Observacion";

  export default {
    name: "DetalleProducto",
    components: {Observacion, Paises, Medida, MarcaProducto},
    computed: {
      flagVentaCaja: {
        get() {
          return this.$store.state.producto.producto.flagVentaCaja;
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "flagVentaCaja", value})
        }
      }
    }
  }
</script>

<style scoped>
  .input-group{
    margin-right: 10px;
  }
</style>
